let getStoreShowSMS = function() {	
	this.showSMS = this.getStoreShowSMS;
    console.log('showSMS', this.showSMS);
};
export default getStoreShowSMS;
